import { matchCalendarModel } from 'models/MatchCalendarModel';
import { repository } from 'repositories/matchCalendarRepository';

class MatchCalendarController {
  getCurrentDayModel() {
    return new Promise((resolve, reject) => {
      const currentDay = matchCalendarModel.getCurrentDay();
      if (currentDay.get('isDownloaded')) {
        resolve();
      } else {
        repository.loadDay(matchCalendarModel.get('currentDay'))
          .then((data) => {
            currentDay.bulkAddMatches(data.matches);
            if (data.nextDay) {
              currentDay.set('nextDay', data.nextDay);
            }
            if (data.prevDay) {
              currentDay.set('prevDay', data.prevDay);
            }
            currentDay.set('isDownloaded', true);
            resolve();
          });
      }
    });
  }
  registerLiveUpdate(day) {
    const interval = repository.getInterval();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      repository.loadDay(day)
        .then((data) => {
          const mainMatch = matchCalendarModel.getCurrentDay()
            .get('matches')[0];

          mainMatch.update(data.matches[0]);
          mainMatch.fireEvent('updateLive');

          if (!mainMatch.get('isLive')) {
            clearInterval(this.intervalId);
          }
        });
    }, interval);
  }
}

const matchCalendarController = new MatchCalendarController();

export default matchCalendarController;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/match-calendar-controller.js